var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShippingRatesService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 150.986,
    viewBox: "0 0 250 150.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    "data-name": "Group 1464",
    transform: "translate(-601.416 -634.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1448",
    "data-name": "Group 1448",
    transform: "translate(636.24 634.229)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    "data-name": "Rectangle 790",
    width: 45.493,
    height: 88.57,
    transform: "translate(154.182 62.416)",
    fill: "#d4e0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M828.042,653.425v-6.868H785.186v6.868h-8.051V787.664h58.957V653.425Z",
    transform: "translate(-673.115 -636.817)",
    fill: "#a4b7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_791",
    "data-name": "Rectangle 791",
    width: 48.428,
    height: 101.863,
    transform: "translate(11.856 49.123)",
    fill: "#a4b7d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M754.229,662.9v-17.18l-8.665-1.529v-9.96h-21.1v9.96l-8.665,1.529V662.9l-11.949,3.161V785.215h62.33V666.059Z",
    transform: "translate(-657.735 -634.229)",
    fill: "#bfcae2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319",
    transform: "translate(51.559 16.217)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205",
    transform: "translate(0.692 24.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    "data-name": "Rectangle 792",
    width: 6.613,
    height: 4.798,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    "data-name": "Rectangle 793",
    width: 6.614,
    height: 4.798,
    transform: "translate(11.353)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_794",
    "data-name": "Rectangle 794",
    width: 6.614,
    height: 4.798,
    transform: "translate(22.527)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_795",
    "data-name": "Rectangle 795",
    width: 6.613,
    height: 4.798,
    transform: "translate(33.879)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_796",
    "data-name": "Rectangle 796",
    width: 6.613,
    height: 4.798,
    transform: "translate(45.053)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203",
    transform: "translate(0 6.486)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_797",
    "data-name": "Rectangle 797",
    width: 6.613,
    height: 4.798,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_798",
    "data-name": "Rectangle 798",
    width: 6.614,
    height: 4.798,
    transform: "translate(11.353)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_799",
    "data-name": "Rectangle 799",
    width: 6.614,
    height: 4.798,
    transform: "translate(22.527)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_800",
    "data-name": "Rectangle 800",
    width: 6.613,
    height: 4.798,
    transform: "translate(33.879)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_801",
    "data-name": "Rectangle 801",
    width: 6.613,
    height: 4.798,
    transform: "translate(45.053)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_802",
    "data-name": "Rectangle 802",
    width: 6.613,
    height: 4.798,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    "data-name": "Rectangle 803",
    width: 6.614,
    height: 4.798,
    transform: "translate(11.353)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_804",
    "data-name": "Rectangle 804",
    width: 6.614,
    height: 4.798,
    transform: "translate(22.527)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    width: 6.613,
    height: 4.798,
    transform: "translate(33.879)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    width: 6.613,
    height: 4.798,
    transform: "translate(45.053)",
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(0 28.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1210",
    "data-name": "Group 1210",
    transform: "translate(45.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    "data-name": "Group 1209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_807",
    "data-name": "Rectangle 807",
    width: 7.997,
    height: 1.244,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    "data-name": "Group 1207",
    transform: "translate(0 6.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    "data-name": "Rectangle 808",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    "data-name": "Group 1208",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_809",
    "data-name": "Rectangle 809",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215",
    transform: "translate(33.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    "data-name": "Group 1214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_810",
    "data-name": "Rectangle 810",
    width: 7.997,
    height: 1.244,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1212",
    "data-name": "Group 1212",
    transform: "translate(0 6.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_811",
    "data-name": "Rectangle 811",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1213",
    "data-name": "Group 1213",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_812",
    "data-name": "Rectangle 812",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    "data-name": "Group 1220",
    transform: "translate(22.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1219",
    "data-name": "Group 1219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    "data-name": "Group 1216"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_813",
    "data-name": "Rectangle 813",
    width: 7.997,
    height: 1.244,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    "data-name": "Group 1217",
    transform: "translate(0 6.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_814",
    "data-name": "Rectangle 814",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    "data-name": "Group 1218",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1225",
    "data-name": "Group 1225",
    transform: "translate(11.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1224",
    "data-name": "Group 1224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 7.997,
    height: 1.244,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    "data-name": "Group 1222",
    transform: "translate(0 6.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1223",
    "data-name": "Group 1223",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_818",
    "data-name": "Rectangle 818",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1226",
    "data-name": "Group 1226"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_819",
    "data-name": "Rectangle 819",
    width: 7.997,
    height: 1.244,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    "data-name": "Group 1229",
    transform: "translate(0 6.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_820",
    "data-name": "Rectangle 820",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_821",
    "data-name": "Rectangle 821",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237",
    transform: "translate(12.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_822",
    "data-name": "Rectangle 822",
    width: 6.069,
    height: 4.403,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_823",
    "data-name": "Rectangle 823",
    width: 6.069,
    height: 4.403,
    transform: "translate(10.42)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_824",
    "data-name": "Rectangle 824",
    width: 6.069,
    height: 4.403,
    transform: "translate(20.673)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1236",
    "data-name": "Group 1236",
    transform: "translate(0 5.952)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_825",
    "data-name": "Rectangle 825",
    width: 6.069,
    height: 4.403,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_826",
    "data-name": "Rectangle 826",
    width: 6.069,
    height: 4.403,
    transform: "translate(10.42)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_827",
    "data-name": "Rectangle 827",
    width: 6.069,
    height: 4.403,
    transform: "translate(20.673)",
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1252",
    "data-name": "Group 1252",
    transform: "translate(11.892 3.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241",
    transform: "translate(20.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    "data-name": "Group 1240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_828",
    "data-name": "Rectangle 828",
    width: 7.338,
    height: 1.142,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239",
    transform: "translate(0 6.034)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_829",
    "data-name": "Rectangle 829",
    width: 7.338,
    height: 1.06,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1245",
    "data-name": "Group 1245",
    transform: "translate(10.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1242",
    "data-name": "Group 1242"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_830",
    "data-name": "Rectangle 830",
    width: 7.339,
    height: 1.142,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243",
    transform: "translate(0 6.034)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_831",
    "data-name": "Rectangle 831",
    width: 7.339,
    height: 1.06,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1251",
    "data-name": "Group 1251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1250",
    "data-name": "Group 1250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1247",
    "data-name": "Group 1247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1246",
    "data-name": "Group 1246"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_832",
    "data-name": "Rectangle 832",
    width: 7.339,
    height: 1.142,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249",
    transform: "translate(0 6.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1248",
    "data-name": "Group 1248"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_833",
    "data-name": "Rectangle 833",
    width: 7.339,
    height: 1.06,
    fill: "#84c3f7"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    "data-name": "Group 1256",
    transform: "translate(0.692 46.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1253",
    "data-name": "Group 1253"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_834",
    "data-name": "Rectangle 834",
    width: 6.613,
    height: 4.798,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_835",
    "data-name": "Rectangle 835",
    width: 6.614,
    height: 4.798,
    transform: "translate(11.353)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_836",
    "data-name": "Rectangle 836",
    width: 6.614,
    height: 4.798,
    transform: "translate(22.527)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_837",
    "data-name": "Rectangle 837",
    width: 6.613,
    height: 4.798,
    transform: "translate(33.879)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_838",
    "data-name": "Rectangle 838",
    width: 6.613,
    height: 4.798,
    transform: "translate(45.053)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1254",
    "data-name": "Group 1254",
    transform: "translate(0 6.487)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_839",
    "data-name": "Rectangle 839",
    width: 6.613,
    height: 4.797,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_840",
    "data-name": "Rectangle 840",
    width: 6.614,
    height: 4.797,
    transform: "translate(11.353)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_841",
    "data-name": "Rectangle 841",
    width: 6.614,
    height: 4.797,
    transform: "translate(22.527)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_842",
    "data-name": "Rectangle 842",
    width: 6.613,
    height: 4.797,
    transform: "translate(33.879)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_843",
    "data-name": "Rectangle 843",
    width: 6.613,
    height: 4.797,
    transform: "translate(45.053)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1255",
    "data-name": "Group 1255",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_844",
    "data-name": "Rectangle 844",
    width: 6.613,
    height: 4.799,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_845",
    "data-name": "Rectangle 845",
    width: 6.614,
    height: 4.799,
    transform: "translate(11.353)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_846",
    "data-name": "Rectangle 846",
    width: 6.614,
    height: 4.799,
    transform: "translate(22.527)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_847",
    "data-name": "Rectangle 847",
    width: 6.613,
    height: 4.799,
    transform: "translate(33.879)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_848",
    "data-name": "Rectangle 848",
    width: 6.613,
    height: 4.799,
    transform: "translate(45.053)",
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1285",
    "data-name": "Group 1285",
    transform: "translate(0 49.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1261",
    "data-name": "Group 1261",
    transform: "translate(45.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1260",
    "data-name": "Group 1260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1257",
    "data-name": "Group 1257"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_849",
    "data-name": "Rectangle 849",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1258",
    "data-name": "Group 1258",
    transform: "translate(0 6.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_850",
    "data-name": "Rectangle 850",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1259",
    "data-name": "Group 1259",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_851",
    "data-name": "Rectangle 851",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1266",
    "data-name": "Group 1266",
    transform: "translate(33.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1262",
    "data-name": "Group 1262"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_852",
    "data-name": "Rectangle 852",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263",
    transform: "translate(0 6.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_853",
    "data-name": "Rectangle 853",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    "data-name": "Group 1264",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_854",
    "data-name": "Rectangle 854",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1271",
    "data-name": "Group 1271",
    transform: "translate(22.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1270",
    "data-name": "Group 1270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1267",
    "data-name": "Group 1267"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_855",
    "data-name": "Rectangle 855",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1268",
    "data-name": "Group 1268",
    transform: "translate(0 6.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_856",
    "data-name": "Rectangle 856",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1269",
    "data-name": "Group 1269",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_857",
    "data-name": "Rectangle 857",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1276",
    "data-name": "Group 1276",
    transform: "translate(11.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1275",
    "data-name": "Group 1275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1272",
    "data-name": "Group 1272"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_858",
    "data-name": "Rectangle 858",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1273",
    "data-name": "Group 1273",
    transform: "translate(0 6.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_859",
    "data-name": "Rectangle 859",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1274",
    "data-name": "Group 1274",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_860",
    "data-name": "Rectangle 860",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1283",
    "data-name": "Group 1283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1278",
    "data-name": "Group 1278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    "data-name": "Group 1277"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_861",
    "data-name": "Rectangle 861",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1280",
    "data-name": "Group 1280",
    transform: "translate(0 6.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1279",
    "data-name": "Group 1279"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_862",
    "data-name": "Rectangle 862",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1282",
    "data-name": "Group 1282",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1281",
    "data-name": "Group 1281"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_863",
    "data-name": "Rectangle 863",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1289",
    "data-name": "Group 1289",
    transform: "translate(0.692 68.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1286",
    "data-name": "Group 1286"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_864",
    "data-name": "Rectangle 864",
    width: 6.613,
    height: 4.798,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_865",
    "data-name": "Rectangle 865",
    width: 6.614,
    height: 4.798,
    transform: "translate(11.353)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_866",
    "data-name": "Rectangle 866",
    width: 6.614,
    height: 4.798,
    transform: "translate(22.527)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    width: 6.613,
    height: 4.798,
    transform: "translate(33.879)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_868",
    "data-name": "Rectangle 868",
    width: 6.613,
    height: 4.798,
    transform: "translate(45.053)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287",
    transform: "translate(0 6.487)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_869",
    "data-name": "Rectangle 869",
    width: 6.613,
    height: 4.797,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_870",
    "data-name": "Rectangle 870",
    width: 6.614,
    height: 4.797,
    transform: "translate(11.353)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_871",
    "data-name": "Rectangle 871",
    width: 6.614,
    height: 4.797,
    transform: "translate(22.527)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_872",
    "data-name": "Rectangle 872",
    width: 6.613,
    height: 4.797,
    transform: "translate(33.879)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_873",
    "data-name": "Rectangle 873",
    width: 6.613,
    height: 4.797,
    transform: "translate(45.053)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1288",
    "data-name": "Group 1288",
    transform: "translate(0 13.239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_874",
    "data-name": "Rectangle 874",
    width: 6.613,
    height: 4.799,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_875",
    "data-name": "Rectangle 875",
    width: 6.614,
    height: 4.799,
    transform: "translate(11.353)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_876",
    "data-name": "Rectangle 876",
    width: 6.614,
    height: 4.799,
    transform: "translate(22.527)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_877",
    "data-name": "Rectangle 877",
    width: 6.613,
    height: 4.799,
    transform: "translate(33.879)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_878",
    "data-name": "Rectangle 878",
    width: 6.613,
    height: 4.799,
    transform: "translate(45.053)",
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318",
    transform: "translate(0 71.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1294",
    "data-name": "Group 1294",
    transform: "translate(45.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1293",
    "data-name": "Group 1293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    "data-name": "Group 1290"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_879",
    "data-name": "Rectangle 879",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1291",
    "data-name": "Group 1291",
    transform: "translate(0 6.576)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_880",
    "data-name": "Rectangle 880",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1292",
    "data-name": "Group 1292",
    transform: "translate(0 13.24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_881",
    "data-name": "Rectangle 881",
    width: 7.997,
    height: 1.244,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1299",
    "data-name": "Group 1299",
    transform: "translate(33.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1298",
    "data-name": "Group 1298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    "data-name": "Group 1295"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_882",
    "data-name": "Rectangle 882",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    "data-name": "Group 1296",
    transform: "translate(0 6.576)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_883",
    "data-name": "Rectangle 883",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    "data-name": "Group 1297",
    transform: "translate(0 13.24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_884",
    "data-name": "Rectangle 884",
    width: 7.997,
    height: 1.244,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1304",
    "data-name": "Group 1304",
    transform: "translate(22.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1303",
    "data-name": "Group 1303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1300",
    "data-name": "Group 1300"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_885",
    "data-name": "Rectangle 885",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1301",
    "data-name": "Group 1301",
    transform: "translate(0 6.576)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886",
    "data-name": "Rectangle 886",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1302",
    "data-name": "Group 1302",
    transform: "translate(0 13.24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887",
    "data-name": "Rectangle 887",
    width: 7.997,
    height: 1.244,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1309",
    "data-name": "Group 1309",
    transform: "translate(11.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1308",
    "data-name": "Group 1308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1305",
    "data-name": "Group 1305"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1306",
    "data-name": "Group 1306",
    transform: "translate(0 6.576)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_889",
    "data-name": "Rectangle 889",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1307",
    "data-name": "Group 1307",
    transform: "translate(0 13.24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_890",
    "data-name": "Rectangle 890",
    width: 7.997,
    height: 1.244,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1316",
    "data-name": "Group 1316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1310",
    "data-name": "Group 1310"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_891",
    "data-name": "Rectangle 891",
    width: 7.997,
    height: 1.245,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1313",
    "data-name": "Group 1313",
    transform: "translate(0 6.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    "data-name": "Group 1312"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_892",
    "data-name": "Rectangle 892",
    width: 7.997,
    height: 1.155,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315",
    transform: "translate(0 13.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1314",
    "data-name": "Group 1314"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893",
    "data-name": "Rectangle 893",
    width: 7.997,
    height: 1.244,
    fill: "#84c3f7"
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_894",
    "data-name": "Rectangle 894",
    width: 37.478,
    height: 109.835,
    transform: "translate(118.74 41.151)",
    fill: "#bfcae2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1384",
    "data-name": "Group 1384",
    transform: "translate(123.978 48.222)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1350",
    "data-name": "Group 1350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    "data-name": "Group 1329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_895",
    "data-name": "Rectangle 895",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1321",
    "data-name": "Group 1321",
    transform: "translate(0 7.386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_896",
    "data-name": "Rectangle 896",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1322",
    "data-name": "Group 1322",
    transform: "translate(0 14.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_897",
    "data-name": "Rectangle 897",
    width: 7.281,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1323",
    "data-name": "Group 1323",
    transform: "translate(0 22.157)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_898",
    "data-name": "Rectangle 898",
    width: 7.281,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324",
    transform: "translate(0 29.543)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_899",
    "data-name": "Rectangle 899",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325",
    transform: "translate(0 36.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_900",
    "data-name": "Rectangle 900",
    width: 7.281,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326",
    transform: "translate(0 44.315)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_901",
    "data-name": "Rectangle 901",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    "data-name": "Group 1327",
    transform: "translate(0 51.701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_902",
    "data-name": "Rectangle 902",
    width: 7.281,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1328",
    "data-name": "Group 1328",
    transform: "translate(0 59.086)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_903",
    "data-name": "Rectangle 903",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339",
    transform: "translate(10.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    "data-name": "Group 1330"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_904",
    "data-name": "Rectangle 904",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(0 7.386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_905",
    "data-name": "Rectangle 905",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332",
    transform: "translate(0 14.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_906",
    "data-name": "Rectangle 906",
    width: 7.281,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333",
    transform: "translate(0 22.157)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_907",
    "data-name": "Rectangle 907",
    width: 7.281,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    "data-name": "Group 1334",
    transform: "translate(0 29.543)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_908",
    "data-name": "Rectangle 908",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335",
    transform: "translate(0 36.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_909",
    "data-name": "Rectangle 909",
    width: 7.281,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336",
    transform: "translate(0 44.315)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_910",
    "data-name": "Rectangle 910",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337",
    transform: "translate(0 51.701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_911",
    "data-name": "Rectangle 911",
    width: 7.281,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338",
    transform: "translate(0 59.086)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_912",
    "data-name": "Rectangle 912",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1349",
    "data-name": "Group 1349",
    transform: "translate(20.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_913",
    "data-name": "Rectangle 913",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341",
    transform: "translate(0 7.386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_914",
    "data-name": "Rectangle 914",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342",
    transform: "translate(0 14.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_915",
    "data-name": "Rectangle 915",
    width: 7.281,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343",
    transform: "translate(0 22.157)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_916",
    "data-name": "Rectangle 916",
    width: 7.281,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344",
    transform: "translate(0 29.543)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_917",
    "data-name": "Rectangle 917",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    "data-name": "Group 1345",
    transform: "translate(0 36.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_918",
    "data-name": "Rectangle 918",
    width: 7.281,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1346",
    "data-name": "Group 1346",
    transform: "translate(0 44.315)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_919",
    "data-name": "Rectangle 919",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1347",
    "data-name": "Group 1347",
    transform: "translate(0 51.701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_920",
    "data-name": "Rectangle 920",
    width: 7.281,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1348",
    "data-name": "Group 1348",
    transform: "translate(0 59.086)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_921",
    "data-name": "Rectangle 921",
    width: 7.281,
    height: 3.059,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1360",
    "data-name": "Group 1360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_922",
    "data-name": "Rectangle 922",
    width: 1.784,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352",
    transform: "translate(0 7.386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_923",
    "data-name": "Rectangle 923",
    width: 1.784,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1353",
    "data-name": "Group 1353",
    transform: "translate(0 14.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_924",
    "data-name": "Rectangle 924",
    width: 1.784,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1354",
    "data-name": "Group 1354",
    transform: "translate(0 22.157)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_925",
    "data-name": "Rectangle 925",
    width: 1.784,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    "data-name": "Group 1355",
    transform: "translate(0 29.543)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_926",
    "data-name": "Rectangle 926",
    width: 1.784,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    "data-name": "Group 1356",
    transform: "translate(0 36.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_927",
    "data-name": "Rectangle 927",
    width: 1.784,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    "data-name": "Group 1357",
    transform: "translate(0 44.315)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_928",
    "data-name": "Rectangle 928",
    width: 1.784,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358",
    transform: "translate(0 51.701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_929",
    "data-name": "Rectangle 929",
    width: 1.784,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    "data-name": "Group 1359",
    transform: "translate(0 59.086)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_930",
    "data-name": "Rectangle 930",
    width: 1.784,
    height: 3.059,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1370",
    "data-name": "Group 1370",
    transform: "translate(10.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1361",
    "data-name": "Group 1361"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_931",
    "data-name": "Rectangle 931",
    width: 1.768,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1362",
    "data-name": "Group 1362",
    transform: "translate(0 7.386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_932",
    "data-name": "Rectangle 932",
    width: 1.768,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1363",
    "data-name": "Group 1363",
    transform: "translate(0 14.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_933",
    "data-name": "Rectangle 933",
    width: 1.768,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1364",
    "data-name": "Group 1364",
    transform: "translate(0 22.157)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_934",
    "data-name": "Rectangle 934",
    width: 1.768,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1365",
    "data-name": "Group 1365",
    transform: "translate(0 29.543)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_935",
    "data-name": "Rectangle 935",
    width: 1.768,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1366",
    "data-name": "Group 1366",
    transform: "translate(0 36.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_936",
    "data-name": "Rectangle 936",
    width: 1.768,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1367",
    "data-name": "Group 1367",
    transform: "translate(0 44.315)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_937",
    "data-name": "Rectangle 937",
    width: 1.768,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    "data-name": "Group 1368",
    transform: "translate(0 51.701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_938",
    "data-name": "Rectangle 938",
    width: 1.768,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1369",
    "data-name": "Group 1369",
    transform: "translate(0 59.086)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_939",
    "data-name": "Rectangle 939",
    width: 1.768,
    height: 3.059,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1380",
    "data-name": "Group 1380",
    transform: "translate(20.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1371",
    "data-name": "Group 1371"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_940",
    "data-name": "Rectangle 940",
    width: 1.656,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1372",
    "data-name": "Group 1372",
    transform: "translate(0 7.386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_941",
    "data-name": "Rectangle 941",
    width: 1.656,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1373",
    "data-name": "Group 1373",
    transform: "translate(0 14.771)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_942",
    "data-name": "Rectangle 942",
    width: 1.656,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1374",
    "data-name": "Group 1374",
    transform: "translate(0 22.157)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_943",
    "data-name": "Rectangle 943",
    width: 1.656,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    "data-name": "Group 1375",
    transform: "translate(0 29.543)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_944",
    "data-name": "Rectangle 944",
    width: 1.656,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376",
    transform: "translate(0 36.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_945",
    "data-name": "Rectangle 945",
    width: 1.656,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1377",
    "data-name": "Group 1377",
    transform: "translate(0 44.315)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_946",
    "data-name": "Rectangle 946",
    width: 1.656,
    height: 3.059,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1378",
    "data-name": "Group 1378",
    transform: "translate(0 51.701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_947",
    "data-name": "Rectangle 947",
    width: 1.656,
    height: 3.06,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    "data-name": "Group 1379",
    transform: "translate(0 59.086)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_948",
    "data-name": "Rectangle 948",
    width: 1.656,
    height: 3.059,
    fill: "#84c3f7"
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_949",
    "data-name": "Rectangle 949",
    width: 43.981,
    height: 69.387,
    transform: "translate(166.428 81.599)",
    fill: "#abb8d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1401",
    "data-name": "Group 1401",
    transform: "translate(175.246 88.726)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    "data-name": "Group 1400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1389",
    "data-name": "Group 1389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_950",
    "data-name": "Rectangle 950",
    width: 5.407,
    height: 10.432,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386",
    transform: "translate(0 15.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_951",
    "data-name": "Rectangle 951",
    width: 5.407,
    height: 10.431,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1387",
    "data-name": "Group 1387",
    transform: "translate(0 30.919)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_952",
    "data-name": "Rectangle 952",
    width: 5.407,
    height: 10.431,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    "data-name": "Group 1388",
    transform: "translate(0 46.379)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_953",
    "data-name": "Rectangle 953",
    width: 5.407,
    height: 10.431,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1394",
    "data-name": "Group 1394",
    transform: "translate(11.14 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1390",
    "data-name": "Group 1390"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_954",
    "data-name": "Rectangle 954",
    width: 5.407,
    height: 10.431,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1391",
    "data-name": "Group 1391",
    transform: "translate(0 15.459)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_955",
    "data-name": "Rectangle 955",
    width: 5.407,
    height: 10.431,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392",
    transform: "translate(0 30.918)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_956",
    "data-name": "Rectangle 956",
    width: 5.407,
    height: 10.431,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1393",
    "data-name": "Group 1393",
    transform: "translate(0 46.378)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_957",
    "data-name": "Rectangle 957",
    width: 5.407,
    height: 10.431,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1399",
    "data-name": "Group 1399",
    transform: "translate(22.28 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    "data-name": "Group 1395"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_958",
    "data-name": "Rectangle 958",
    width: 5.407,
    height: 10.431,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1396",
    "data-name": "Group 1396",
    transform: "translate(0 15.459)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_959",
    "data-name": "Rectangle 959",
    width: 5.407,
    height: 10.431,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1397",
    "data-name": "Group 1397",
    transform: "translate(0 30.918)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_960",
    "data-name": "Rectangle 960",
    width: 5.407,
    height: 10.431,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1398",
    "data-name": "Group 1398",
    transform: "translate(0 46.378)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_961",
    "data-name": "Rectangle 961",
    width: 5.407,
    height: 10.431,
    fill: "#84c3f7"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M688.709,755.674h-43.22v3.777h1.021V810.7h40.8V759.451h1.394Z",
    transform: "translate(-645.489 -659.714)",
    fill: "#bfcae2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1402",
    "data-name": "Group 1402",
    transform: "translate(7.184 109.243)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_962",
    "data-name": "Rectangle 962",
    width: 25.269,
    height: 4.785,
    transform: "translate(1.222 0.591)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_963",
    "data-name": "Rectangle 963",
    width: 25.269,
    height: 4.785,
    transform: "translate(1.222 7.683)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_964",
    "data-name": "Rectangle 964",
    width: 25.269,
    height: 4.785,
    transform: "translate(1.222 14.776)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_965",
    "data-name": "Rectangle 965",
    width: 25.269,
    height: 4.786,
    transform: "translate(1.222 21.867)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_966",
    "data-name": "Rectangle 966",
    width: 25.269,
    height: 4.785,
    transform: "translate(1.222 36.053)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_967",
    "data-name": "Rectangle 967",
    width: 25.269,
    height: 4.786,
    transform: "translate(1.222 28.96)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_968",
    "data-name": "Rectangle 968",
    width: 1.222,
    height: 41.604,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_969",
    "data-name": "Rectangle 969",
    width: 1.222,
    height: 41.604,
    transform: "translate(25.881 0.138)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M730.528,789.333H670.008v3.777h1.468v24.653h56.862V793.11h2.189Z",
    transform: "translate(-650.634 -666.778)",
    fill: "#abb8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M817.286,776.326V741.842H778.263v34.484H762.237V807.8h71.076V776.326Z",
    transform: "translate(-669.988 -656.812)",
    fill: "#abb8d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    "data-name": "Group 1413",
    transform: "translate(100.618 90.538)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1412",
    "data-name": "Group 1412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1403",
    "data-name": "Group 1403",
    transform: "translate(0 39.213)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_970",
    "data-name": "Rectangle 970",
    width: 54.337,
    height: 7.31,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1404",
    "data-name": "Group 1404",
    transform: "translate(0 50.046)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_971",
    "data-name": "Rectangle 971",
    width: 54.337,
    height: 7.31,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1408",
    "data-name": "Group 1408",
    transform: "translate(14.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1405",
    "data-name": "Group 1405"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_972",
    "data-name": "Rectangle 972",
    width: 24.897,
    height: 7.31,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1406",
    "data-name": "Group 1406",
    transform: "translate(0 10.833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    width: 24.897,
    height: 7.31,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1407",
    "data-name": "Group 1407",
    transform: "translate(0 21.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_974",
    "data-name": "Rectangle 974",
    width: 24.897,
    height: 7.309,
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1409",
    "data-name": "Group 1409",
    transform: "translate(12.792 28.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_975",
    "data-name": "Rectangle 975",
    width: 28.872,
    height: 1.555,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1410",
    "data-name": "Group 1410",
    transform: "translate(12.792 17.365)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 28.872,
    height: 1.556,
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1411",
    "data-name": "Group 1411",
    transform: "translate(12.792 6.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_977",
    "data-name": "Rectangle 977",
    width: 28.872,
    height: 1.555,
    fill: "#84c3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1417",
    "data-name": "Group 1417",
    transform: "translate(26.417 127.025)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1414",
    "data-name": "Group 1414"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_978",
    "data-name": "Rectangle 978",
    width: 5.82,
    height: 5.071,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    width: 5.821,
    height: 5.071,
    transform: "translate(9.992)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_980",
    "data-name": "Rectangle 980",
    width: 5.821,
    height: 5.071,
    transform: "translate(19.825)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_981",
    "data-name": "Rectangle 981",
    width: 5.82,
    height: 5.071,
    transform: "translate(29.817)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_982",
    "data-name": "Rectangle 982",
    width: 5.82,
    height: 5.071,
    transform: "translate(39.65)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    "data-name": "Group 1415",
    transform: "translate(0 6.855)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_983",
    "data-name": "Rectangle 983",
    width: 5.82,
    height: 5.07,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_984",
    "data-name": "Rectangle 984",
    width: 5.821,
    height: 5.07,
    transform: "translate(9.992)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_985",
    "data-name": "Rectangle 985",
    width: 5.821,
    height: 5.07,
    transform: "translate(19.825)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    "data-name": "Rectangle 986",
    width: 5.82,
    height: 5.07,
    transform: "translate(29.817)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    width: 5.82,
    height: 5.07,
    transform: "translate(39.65)",
    fill: "#84c3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    "data-name": "Group 1416",
    transform: "translate(0 13.99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_988",
    "data-name": "Rectangle 988",
    width: 5.82,
    height: 5.071,
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_989",
    "data-name": "Rectangle 989",
    width: 5.821,
    height: 5.071,
    transform: "translate(9.992)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_990",
    "data-name": "Rectangle 990",
    width: 5.821,
    height: 5.071,
    transform: "translate(19.825)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    width: 5.82,
    height: 5.071,
    transform: "translate(29.817)",
    fill: "#84c3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992",
    "data-name": "Rectangle 992",
    width: 5.82,
    height: 5.071,
    transform: "translate(39.65)",
    fill: "#84c3f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1447",
    "data-name": "Group 1447",
    transform: "translate(25.862 130.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1446",
    "data-name": "Group 1446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422",
    transform: "translate(39.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1418",
    "data-name": "Group 1418"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_993",
    "data-name": "Rectangle 993",
    width: 7.044,
    height: 1.311,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1419",
    "data-name": "Group 1419",
    transform: "translate(0 6.924)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_994",
    "data-name": "Rectangle 994",
    width: 7.044,
    height: 1.216,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1420",
    "data-name": "Group 1420",
    transform: "translate(0 13.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_995",
    "data-name": "Rectangle 995",
    width: 7.044,
    height: 1.31,
    fill: "#a3cbe5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1427",
    "data-name": "Group 1427",
    transform: "translate(29.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1426",
    "data-name": "Group 1426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1423",
    "data-name": "Group 1423"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_996",
    "data-name": "Rectangle 996",
    width: 7.044,
    height: 1.311,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1424",
    "data-name": "Group 1424",
    transform: "translate(0 6.924)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_997",
    "data-name": "Rectangle 997",
    width: 7.044,
    height: 1.216,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1425",
    "data-name": "Group 1425",
    transform: "translate(0 13.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_998",
    "data-name": "Rectangle 998",
    width: 7.044,
    height: 1.31,
    fill: "#a3cbe5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1432",
    "data-name": "Group 1432",
    transform: "translate(19.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1428",
    "data-name": "Group 1428"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_999",
    "data-name": "Rectangle 999",
    width: 7.044,
    height: 1.311,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1429",
    "data-name": "Group 1429",
    transform: "translate(0 6.924)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1000",
    "data-name": "Rectangle 1000",
    width: 7.044,
    height: 1.216,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430",
    transform: "translate(0 13.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1001",
    "data-name": "Rectangle 1001",
    width: 7.044,
    height: 1.31,
    fill: "#a3cbe5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1437",
    "data-name": "Group 1437",
    transform: "translate(10.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1436",
    "data-name": "Group 1436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1433",
    "data-name": "Group 1433"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1002",
    "data-name": "Rectangle 1002",
    width: 7.044,
    height: 1.311,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1434",
    "data-name": "Group 1434",
    transform: "translate(0 6.924)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1003",
    "data-name": "Rectangle 1003",
    width: 7.044,
    height: 1.216,
    fill: "#a3cbe5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1435",
    "data-name": "Group 1435",
    transform: "translate(0 13.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1004",
    "data-name": "Rectangle 1004",
    width: 7.044,
    height: 1.31,
    fill: "#a3cbe5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1445",
    "data-name": "Group 1445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1444",
    "data-name": "Group 1444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1439",
    "data-name": "Group 1439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1438",
    "data-name": "Group 1438"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1005",
    "data-name": "Rectangle 1005",
    width: 7.044,
    height: 1.311,
    fill: "#a3cbe5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1441",
    "data-name": "Group 1441",
    transform: "translate(0 6.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1440",
    "data-name": "Group 1440"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1006",
    "data-name": "Rectangle 1006",
    width: 7.044,
    height: 1.216,
    fill: "#a3cbe5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1443",
    "data-name": "Group 1443",
    transform: "translate(0 13.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1442",
    "data-name": "Group 1442"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1007",
    "data-name": "Rectangle 1007",
    width: 7.044,
    height: 1.31,
    fill: "#a3cbe5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1451",
    "data-name": "Group 1451",
    transform: "translate(762.303 662.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1450",
    "data-name": "Group 1450",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M821.539,690.849,811.5,683.881a3.074,3.074,0,0,0-2.627-.421l-.925.276a.379.379,0,0,0-.236.524l4.389,9.4Z",
    transform: "translate(-805.586 -672.395)",
    fill: "#572680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M821.331,691.749l1.249.866-9.443,2.808-.507-1.087Z",
    transform: "translate(-806.626 -674.161)",
    fill: "#47206d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M810.477,694.78l24.285.5a16.331,16.331,0,0,0,4.991-.674l41.807-12.431a27.137,27.137,0,0,0,8.891-4.562l3.312-2.566a2.87,2.87,0,0,0-1.525-5.129l-4.175-.34a27.144,27.144,0,0,0-9.939,1.037l-68.172,20.27a1.989,1.989,0,0,0-1.339,2.473h0A1.988,1.988,0,0,0,810.477,694.78Z",
    transform: "translate(-805.765 -669.49)",
    fill: "#acacfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M896.634,672.123a2.841,2.841,0,0,1-.845,3.477l-3.714,2.32a25.791,25.791,0,0,1-8.8,4.17L841.7,694.82a15.227,15.227,0,0,1-4.8.775l-10.641.021-8.082-.167Z",
    transform: "translate(-807.791 -670.042)",
    fill: "#572680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M898.7,675.406a2.9,2.9,0,0,1-.765.883l-3.312,2.566a27.137,27.137,0,0,1-8.891,4.562l-41.807,12.431a18.256,18.256,0,0,1-5.277.713l-10.238-.255Z",
    transform: "translate(-809.937 -670.731)",
    fill: "#d5d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M905.984,669.939l1.414-.42c.371.015.744.036,1.115.066l2.641.215-4.788,1.424Z",
    transform: "translate(-826.216 -669.496)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M904.122,670.514l.833-.247.382,1.284-.834.248a.439.439,0,0,1-.546-.3l-.132-.443A.439.439,0,0,1,904.122,670.514Z",
    transform: "translate(-825.759 -669.653)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1008",
    "data-name": "Rectangle 1008",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "translate(65.645 4.643) rotate(-16.559)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1009",
    "data-name": "Rectangle 1009",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "translate(63.666 5.231) rotate(-16.559)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1010",
    "data-name": "Rectangle 1010",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "matrix(0.959, -0.285, 0.285, 0.959, 61.688, 5.82)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1011",
    "data-name": "Rectangle 1011",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "matrix(0.959, -0.285, 0.285, 0.959, 59.709, 6.408)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "matrix(0.959, -0.285, 0.285, 0.959, 57.73, 6.996)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1013",
    "data-name": "Rectangle 1013",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "translate(55.751 7.585) rotate(-16.561)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1014",
    "data-name": "Rectangle 1014",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "matrix(0.959, -0.285, 0.285, 0.959, 53.772, 8.173)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1015",
    "data-name": "Rectangle 1015",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "matrix(0.959, -0.285, 0.285, 0.959, 51.794, 8.761)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1016",
    "data-name": "Rectangle 1016",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "translate(49.815 9.35) rotate(-16.559)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1017",
    "data-name": "Rectangle 1017",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "matrix(0.959, -0.285, 0.285, 0.959, 47.836, 9.938)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1018",
    "data-name": "Rectangle 1018",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "translate(45.857 10.526) rotate(-16.56)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1019",
    "data-name": "Rectangle 1019",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "translate(43.879 11.115) rotate(-16.56)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1020",
    "data-name": "Rectangle 1020",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "matrix(0.959, -0.285, 0.285, 0.959, 41.9, 11.703)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "translate(32.006 14.645) rotate(-16.561)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1022",
    "data-name": "Rectangle 1022",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "translate(30.027 15.233) rotate(-16.557)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1023",
    "data-name": "Rectangle 1023",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "matrix(0.959, -0.285, 0.285, 0.959, 28.048, 15.822)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1024",
    "data-name": "Rectangle 1024",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "matrix(0.959, -0.285, 0.285, 0.959, 26.07, 16.41)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1025",
    "data-name": "Rectangle 1025",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "matrix(0.959, -0.285, 0.285, 0.959, 24.091, 16.998)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1026",
    "data-name": "Rectangle 1026",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "translate(22.112 17.587) rotate(-16.56)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1027",
    "data-name": "Rectangle 1027",
    width: 1.34,
    height: 1.34,
    rx: 0.398,
    transform: "translate(20.133 18.175) rotate(-16.56)",
    fill: "#2d1747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M874.087,688.514l-25.193-4.743a3.622,3.622,0,0,0-1.7.088l-1.342.4a.45.45,0,0,0-.079.831l14.836,7.684Z",
    transform: "translate(-813.529 -672.473)",
    fill: "#5f3389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M870,689.795l-23.151-5.769-1,.3a.45.45,0,0,0-.079.831l14.836,7.684Z",
    transform: "translate(-813.529 -672.54)",
    fill: "#47206d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M875.561,690.176l-13.636,4.055a11.692,11.692,0,0,0-4.483,2.51h0a9.309,9.309,0,0,0,5.509.062l13.4-3.983Z",
    transform: "translate(-816.03 -673.831)",
    fill: "#c2c2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M875.91,691.588l.454,1.527-13.4,3.983a9.309,9.309,0,0,1-5.446-.043Z",
    transform: "translate(-816.047 -674.127)",
    fill: "#d4d4f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1449",
    "data-name": "Group 1449",
    transform: "translate(54.049 13.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M875.226,691.739l1.749-.52a.412.412,0,0,1,.513.277l.642,2.162a.411.411,0,0,1-.277.512l-1.749.521a2.355,2.355,0,0,1-1.957-.284l-.592-.386a.264.264,0,0,1-.1-.329l.285-.646A2.355,2.355,0,0,1,875.226,691.739Z",
    transform: "translate(-873.435 -687.555)",
    fill: "#572680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M878.081,688.213l5.346-1.59a.888.888,0,0,1,1.1.6l1.383,4.652a.887.887,0,0,1-.6,1.1l-5.346,1.59a3.314,3.314,0,1,1-1.889-6.353Z",
    transform: "translate(-873.912 -686.586)",
    fill: "#d5d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M875.836,692.281a3.313,3.313,0,0,1,2.245-4.068l5.346-1.59a.888.888,0,0,1,1.1.6l.676,2.273Z",
    transform: "translate(-873.913 -686.586)",
    fill: "#c2c2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M884.851,688.752l.356,1.2-9.37,2.787a3.308,3.308,0,0,1-.1-1.274Z",
    transform: "translate(-873.913 -687.041)",
    fill: "#e3e3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M885.2,686.688l.217-.065a.888.888,0,0,1,1.1.6l1.383,4.652a.887.887,0,0,1-.6,1.1l-.217.065Z",
    transform: "translate(-875.904 -686.586)",
    fill: "#572680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M887.461,690.325l.694,2.333a.887.887,0,0,1-.6,1.1l-.217.065-.947-3.183Z",
    transform: "translate(-876.154 -687.371)",
    fill: "#401b63"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M816.057,697.147l-8.839.687-2.187.65,5.027.446Z",
    transform: "translate(-805.031 -675.294)",
    fill: "#572680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M811.313,698.931l-.3-.027,5.472-1.692.831-.065Z",
    transform: "translate(-806.286 -675.294)",
    fill: "#47206d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M810.5,700.535l.708-1.6,6-1.784-1.384,3.539-4.931-.1A1.969,1.969,0,0,1,810.5,700.535Z",
    transform: "translate(-806.178 -675.294)",
    opacity: 0.15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1461",
    "data-name": "Group 1461",
    transform: "translate(630.743 695.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1452",
    "data-name": "Group 1452",
    transform: "translate(105.2 68.292)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_546",
    "data-name": "Ellipse 546",
    cx: 10.732,
    cy: 10.732,
    r: 10.732,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_547",
    "data-name": "Ellipse 547",
    cx: 10.732,
    cy: 10.732,
    r: 10.732,
    transform: "translate(1.626)",
    fill: "#494849"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_548",
    "data-name": "Ellipse 548",
    cx: 6.179,
    cy: 6.179,
    r: 6.179,
    transform: "translate(6.179 4.553)",
    fill: "#282828"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1453",
    "data-name": "Group 1453",
    transform: "translate(18.495 68.292)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_549",
    "data-name": "Ellipse 549",
    cx: 10.732,
    cy: 10.732,
    r: 10.732,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_550",
    "data-name": "Ellipse 550",
    cx: 10.732,
    cy: 10.732,
    r: 10.732,
    transform: "translate(1.626)",
    fill: "#494849"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_551",
    "data-name": "Ellipse 551",
    cx: 6.179,
    cy: 6.179,
    r: 6.179,
    transform: "translate(6.179 4.553)",
    fill: "#282828"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1454",
    "data-name": "Group 1454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1028",
    "data-name": "Rectangle 1028",
    d: "M4.216,0H31.032a0,0,0,0,1,0,0V80.177a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4.216A4.216,4.216,0,0,1,4.216,0Z",
    transform: "translate(1.657)",
    fill: "#7c43a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1029",
    "data-name": "Rectangle 1029",
    width: 3.482,
    height: 63.795,
    transform: "translate(6.234 7.095)",
    fill: "#9a4dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1030",
    "data-name": "Rectangle 1030",
    width: 22.973,
    height: 63.795,
    transform: "translate(9.716 7.095)",
    fill: "#45305e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1031",
    "data-name": "Rectangle 1031",
    d: "M2.346,0H37.986a0,0,0,0,1,0,0V6.031a0,0,0,0,1,0,0H2.346A2.346,2.346,0,0,1,0,3.685V2.346A2.346,2.346,0,0,1,2.346,0Z",
    transform: "translate(0 74.146)",
    fill: "#572680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M650.827,720.7l16.192,63.795H650.827Z",
    transform: "translate(-641.111 -713.601)",
    fill: "#341f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1032",
    "data-name": "Rectangle 1032",
    d: "M1.32,0h0a3.04,3.04,0,0,1,3.04,3.04v.305a3.04,3.04,0,0,1-3.04,3.04h0A1.32,1.32,0,0,1,0,5.065V1.32A1.32,1.32,0,0,1,1.32,0Z",
    transform: "translate(0.513 64.504)",
    fill: "#e52364"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1455",
    "data-name": "Group 1455",
    transform: "translate(12.142 49.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1033",
    "data-name": "Rectangle 1033",
    width: 28.281,
    height: 21.093,
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1034",
    "data-name": "Rectangle 1034",
    width: 8.692,
    height: 21.093,
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1035",
    "data-name": "Rectangle 1035",
    width: 3.83,
    height: 1.572,
    transform: "translate(21.669 17.127)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1036",
    "data-name": "Rectangle 1036",
    width: 1.572,
    height: 1.572,
    transform: "translate(11.203 17.127)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1037",
    "data-name": "Rectangle 1037",
    width: 1.572,
    height: 1.572,
    transform: "translate(13.355 17.127)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1456",
    "data-name": "Group 1456",
    transform: "translate(15.042 28.179)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1038",
    "data-name": "Rectangle 1038",
    width: 28.369,
    height: 21.159,
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1039",
    "data-name": "Rectangle 1039",
    width: 8.719,
    height: 21.159,
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1040",
    "data-name": "Rectangle 1040",
    width: 3.842,
    height: 1.577,
    transform: "translate(21.736 17.18)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1041",
    "data-name": "Rectangle 1041",
    width: 1.577,
    height: 1.577,
    transform: "translate(11.238 17.18)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1042",
    "data-name": "Rectangle 1042",
    width: 1.577,
    height: 1.577,
    transform: "translate(13.396 17.18)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1457",
    "data-name": "Group 1457",
    transform: "translate(32.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M843.4,761.824,828.76,742.485a18.154,18.154,0,0,0-14.474-7.2h-20.6V796.84h53.392V772.781A18.156,18.156,0,0,0,843.4,761.824Z",
    transform: "translate(-703.779 -716.663)",
    fill: "#5f1e84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1043",
    "data-name": "Rectangle 1043",
    d: "M0,0H51.8a2.206,2.206,0,0,1,2.206,2.206v1.62A2.206,2.206,0,0,1,51.8,6.031H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(91.506 74.146)",
    fill: "#2f0f49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M822.653,794.629a13.51,13.51,0,0,0-13.511,13.511c0,.389.02.772.052,1.153h26.917c.032-.381.053-.764.053-1.153A13.511,13.511,0,0,0,822.653,794.629Z",
    transform: "translate(-707.022 -729.115)",
    fill: "#1c0c2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1044",
    "data-name": "Rectangle 1044",
    width: 12.594,
    height: 61.552,
    transform: "translate(78.912 18.625)",
    fill: "#461666"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1045",
    "data-name": "Rectangle 1045",
    width: 9.948,
    height: 74.146,
    fill: "#7c43a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1046",
    "data-name": "Rectangle 1046",
    d: "M0,0H74.61a4.148,4.148,0,0,1,4.148,4.148V80.177a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(5.298)",
    fill: "#5f1e84"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1047",
    "data-name": "Rectangle 1047",
    width: 78.758,
    height: 6.031,
    transform: "translate(5.298 74.146)",
    fill: "#2f0f49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M717.057,794.629a13.51,13.51,0,0,0-13.511,13.511c0,.389.02.772.052,1.153h26.917c.032-.381.052-.764.052-1.153A13.51,13.51,0,0,0,717.057,794.629Z",
    transform: "translate(-684.863 -729.115)",
    fill: "#1c0c2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1048",
    "data-name": "Rectangle 1048",
    width: 7.45,
    height: 6.031,
    transform: "translate(84.056 74.146)",
    fill: "#200c3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1049",
    "data-name": "Rectangle 1049",
    d: "M0,0H1.2a3.16,3.16,0,0,1,3.16,3.16v.065A3.16,3.16,0,0,1,1.2,6.386H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(5.298 70.89) rotate(180)",
    fill: "#e52364"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1050",
    "data-name": "Rectangle 1050",
    width: 3.902,
    height: 6.386,
    transform: "translate(5.298 64.504)",
    fill: "#aa2256"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1458",
    "data-name": "Group 1458",
    transform: "translate(136.495 68.292)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_552",
    "data-name": "Ellipse 552",
    cx: 10.732,
    cy: 10.732,
    r: 10.732,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_553",
    "data-name": "Ellipse 553",
    cx: 10.732,
    cy: 10.732,
    r: 10.732,
    transform: "translate(1.626)",
    fill: "#494849"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    cx: 6.179,
    cy: 6.179,
    r: 6.179,
    transform: "translate(6.179 4.553)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M830.579,811.02a.4.4,0,0,1-.4-.4,3.373,3.373,0,0,0-3.369-3.369.4.4,0,0,1,0-.8,4.174,4.174,0,0,1,4.17,4.169A.4.4,0,0,1,830.579,811.02Z",
    transform: "translate(-814.452 -799.889)",
    fill: "#494849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1459",
    "data-name": "Group 1459",
    transform: "translate(52.946 68.292)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 10.732,
    cy: 10.732,
    r: 10.732,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_556",
    "data-name": "Ellipse 556",
    cx: 10.732,
    cy: 10.732,
    r: 10.732,
    transform: "translate(1.626)",
    fill: "#494849"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_557",
    "data-name": "Ellipse 557",
    cx: 6.179,
    cy: 6.179,
    r: 6.179,
    transform: "translate(6.179 4.553)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M724.841,811.048a.4.4,0,0,1-.4-.4,3.374,3.374,0,0,0-3.369-3.37.4.4,0,0,1,0-.8,4.174,4.174,0,0,1,4.17,4.17A.4.4,0,0,1,724.841,811.048Z",
    transform: "translate(-708.714 -799.895)",
    fill: "#494849"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1051",
    "data-name": "Rectangle 1051",
    width: 7.524,
    height: 22.35,
    rx: 2.673,
    transform: "translate(128.971 25.425)",
    fill: "#4e2072"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1460",
    "data-name": "Group 1460",
    transform: "translate(139.804 25.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M839.76,761.369l-7.821-11.4c-2.539,3.654-5.4,7.755-7.953,11.4Z",
    transform: "translate(-817.252 -745.168)",
    fill: "#80aac1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M822.217,743.894h-4.561a2.191,2.191,0,0,0-2.192,2.191v14.009H822.2c2.551-3.647,5.414-7.748,7.953-11.4l-.666-.971A8.813,8.813,0,0,0,822.217,743.894Z",
    transform: "translate(-815.464 -743.894)",
    fill: "#95bcce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M818.539,772.177h.216c-.07,0-.14-.006-.209-.011Z",
    transform: "translate(-816.109 -749.827)",
    fill: "#b77430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M841.281,768.277l-2.662-3.88H822.845c-1.613,2.307-3.1,4.428-4.3,6.139.069.005.138.011.209.011h21.329A1.449,1.449,0,0,0,841.281,768.277Z",
    transform: "translate(-816.111 -748.196)",
    fill: "#6595aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M815.464,767.9a2.644,2.644,0,0,0,2.437,2.634c1.2-1.711,2.684-3.832,4.3-6.139h-6.734Z",
    transform: "translate(-815.464 -748.196)",
    fill: "#7ba7b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1052",
    "data-name": "Rectangle 1052",
    d: "M0,0H4.172a3.16,3.16,0,0,1,3.16,3.16v.065a3.16,3.16,0,0,1-3.16,3.16H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(170.871 64.686)",
    fill: "#f4a506"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1053",
    "data-name": "Rectangle 1053",
    width: 50.894,
    height: 27.975,
    rx: 2.451,
    transform: "translate(49.903 16.72)",
    fill: "#7c43a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1462",
    "data-name": "Group 1462",
    transform: "translate(601.416 764.122)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1054",
    "data-name": "Rectangle 1054",
    width: 28.281,
    height: 21.093,
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1055",
    "data-name": "Rectangle 1055",
    width: 8.692,
    height: 21.093,
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1056",
    "data-name": "Rectangle 1056",
    width: 3.83,
    height: 1.572,
    transform: "translate(21.669 17.127)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1057",
    "data-name": "Rectangle 1057",
    width: 1.572,
    height: 1.572,
    transform: "translate(11.203 17.127)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1058",
    "data-name": "Rectangle 1058",
    width: 1.572,
    height: 1.572,
    transform: "translate(13.355 17.127)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463",
    transform: "translate(606.358 747.812)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1059",
    "data-name": "Rectangle 1059",
    width: 21.051,
    height: 15.701,
    transform: "translate(0)",
    fill: "#f1b776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1060",
    "data-name": "Rectangle 1060",
    width: 6.47,
    height: 15.701,
    transform: "translate(0)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1061",
    "data-name": "Rectangle 1061",
    width: 3.83,
    height: 1.572,
    transform: "translate(14.439 11.735)",
    fill: "#faffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1062",
    "data-name": "Rectangle 1062",
    width: 1.572,
    height: 1.572,
    transform: "translate(8.714 11.735)",
    fill: "#a55927"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1063",
    "data-name": "Rectangle 1063",
    width: 1.572,
    height: 1.572,
    transform: "translate(10.866 11.735)",
    fill: "#a55927"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M667.3,798.775l-22.219,18.8H619.857l20.99-18.774Z",
    transform: "translate(-3.87 -34.53)",
    fill: "#7c43a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M674,800.875v-2.1l-22.219,18.8v2.166Z",
    transform: "translate(-10.569 -34.53)",
    fill: "#2f0f49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1064",
    "data-name": "Rectangle 1064",
    width: 25.226,
    height: 2.166,
    transform: "translate(615.987 783.049)",
    fill: "#572680"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingRatesService);
export default __webpack_public_path__ + "static/media/shipping-rates-service.2d3de7cb94fa75da1999349213ca459c.svg";
export { ForwardRef as ReactComponent };